import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { useParams } from "react-router-dom";
import { getBadge } from "./actions";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import LocalStrings from "@language";

const Badge = (props) => {
  // console.log("manageTicketsCount :- ", manageTicketsCount);
  const { eventData, session } = props;
  const { appuserid } = useParams();
  // console.log(appuserid, eventData);
  const [content, setcontent] = useState("");
  const [width, setwidth] = useState("");
  const [height, setheight] = useState("");
  const [measurement, setmeasurement] = useState("cm");
  const convertToPoint = (val) => {
    let point = val * 0.75;

    return point;
  };
  useEffect(() => {
    let data = { eventid: eventData?.eventid };
    if (appuserid) {
      data.appuserid = appuserid;
    }

    props.getBadge(session, data, (test) => {
      // console.log({ test });
      setcontent(test.data.badge);
      setwidth(test.data.boxWidth);
      setheight(test.data.boxHeight);
      setmeasurement(test.data.measurement);
    });
  }, [eventData?.eventid, appuserid]);
  const handleDownload = async () => {
    const element = document.getElementById("pdf-content");

    // Get exact size of the HTML content
    const canvas = await html2canvas(element, {
      scale: 10, // Higher scale = better quality
      useCORS: true, // if using external images/fonts
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: width > height ? "landscape" : "portrait",
      unit: "pt",
      format: [convertToPoint(width), convertToPoint(height)], // exact match
    });

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      convertToPoint(width),
      convertToPoint(height)
    );
    pdf.save("custom-size.pdf");
  };

  return (
    <>
      <div className="flex items-center justify-center h-screen w-screen relative">
        <button
          onClick={handleDownload}
          className=" absolute top-4 flex gap-2 theme-button-md"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          {LocalStrings.kDownloadText}
        </button>
        <div style={{ border: "gray 1px solid" }} className="mt-4">
          <div id="pdf-content" dangerouslySetInnerHTML={{ __html: content }} />{" "}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    eventData: state.eventData,
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getBadge }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Badge);
